"use client";
import { RangerEventWithParticipantsAndUpdates } from "@/db/rangers";
import { RangerEvents } from "@/prisma/generated/browser";
import { Stack, Typography } from "@mui/material";
import EventOptionsChips from "../../displays/EventOptionsChips";
import CollapsibleDropdown from "./CollapsibleDropdown";

type props = {
  event: RangerEvents;
  open: boolean;
  inline?: boolean;
};

export default function EventsDropdown({ event, open, inline }: props) {
  const content = (
    <Stack spacing={1}>
      <EventOptionsChips event={event as RangerEventWithParticipantsAndUpdates} />
      <Typography
        variant="body1"
        sx={{
          whiteSpace: "pre-wrap"
        }}
      >
        {event.description}
      </Typography>
    </Stack>
  );

  const officialSx = event.official
    ? {
        borderLeft: 5,
        borderLeftColor: "warning.main",
        borderRight: 5,
        borderRightColor: "warning.main"
      }
    : undefined;

  return (
    <CollapsibleDropdown
      open={open}
      colSpan={10}
      content={content}
      inline={inline}
      rowSx={officialSx}
      cellSx={officialSx}
    />
  );
}
